import { FilterFilled, FilterOutlined } from '@ant-design/icons';
import { Dropdown, Space } from 'antd';
import { useState } from 'react';
import styled from 'styled-components';

import { Button, Checkbox } from '../../../../../components/index';
import { DockingBillingStatusType } from '../../../../../types';
import { dockingBillingStatusList } from '../../../../../utils/lists';

const FilterOverlay = styled.div`
  background: #fff;
  border-radius: 2px;
  box-shadow: 0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 6px 16px rgba(0, 0, 0, 0.08);
  padding: 8px 12px;
  text-transform: none;

  .filter-footer {
    border-top: 1px solid var(--neutral_lighter);
    display: flex;
    justify-content: flex-end;
    margin-top: 8px;
    padding-top: 8px;
  }
`;

const FilterTrigger = styled.span<{ $isActive: boolean }>`
  color: ${(props) =>
    props.$isActive ? 'var(--green-sea_dark)' : 'var(--neutral_medium)'};
  cursor: pointer;
  margin-inline-start: 6px;

  &:hover {
    color: var(--neutral_dark);
  }
`;

type BillingStatusFilterProps = {
  selectedBillingStatus: DockingBillingStatusType[];
  onChangeBillingStatus: (status: DockingBillingStatusType[]) => void;
};

export function BillingStatusFilter(props: BillingStatusFilterProps) {
  const { selectedBillingStatus, onChangeBillingStatus } = props;

  const [isVisible, setIsVisible] = useState(false);

  const isActive = selectedBillingStatus.length > 0;

  function onToggleStatus(
    status: DockingBillingStatusType,
    isChecked: boolean
  ) {
    onChangeBillingStatus(
      isChecked
        ? [...selectedBillingStatus, status]
        : selectedBillingStatus.filter((item) => item !== status)
    );
  }

  return (
    <Dropdown
      trigger={['click']}
      placement="bottomRight"
      visible={isVisible}
      onVisibleChange={setIsVisible}
      overlay={
        <FilterOverlay>
          <Space direction="vertical" size={4}>
            {dockingBillingStatusList.map((status) => (
              <Checkbox
                key={status.id}
                checked={selectedBillingStatus.includes(status.id)}
                onChange={(e) => onToggleStatus(status.id, e.target.checked)}
              >
                {status.name}
              </Checkbox>
            ))}
          </Space>
          <div className="filter-footer">
            <Button
              type="text"
              size="small"
              disabled={!isActive}
              onClick={() => onChangeBillingStatus([])}
            >
              Limpar
            </Button>
          </div>
        </FilterOverlay>
      }
    >
      <FilterTrigger
        $isActive={isActive}
        title={
          isActive
            ? `Filtrando por ${selectedBillingStatus.length} status`
            : 'Filtrar por status do faturamento'
        }
      >
        {isActive ? <FilterFilled /> : <FilterOutlined />}
      </FilterTrigger>
    </Dropdown>
  );
}
